export const MIXPANEL_PRODUCT = 'ted.com';
